export default {
  EntityDetails: 'entityDetails',
  SearchOptions: 'searchOptions'
}
